import {SiteProviderKind} from "../types/site-provider-kind.type";
import {SiteProviderType} from "../types/site-provider.type";

/**
 * Which providerType values the UI offers per providerKind.
 *
 * The kind/type pair is validated server-side by SchedulingProjectDataSourceValidator, which
 * rejects anything outside the kind's own enum - UNITS has no prediction type and DELIVERY_TIME
 * has no projection type, so those tabs offer a single choice. Widening this list is not a
 * front-end decision: the matching enum has to gain the constant first.
 *
 * DEFAULT exists under every kind on the server but is deliberately left out of the UI.
 */
export const SITE_PROVIDER_TYPE_OPTIONS: { [key in SiteProviderKind]: SiteProviderType[] } = {
  [SiteProviderKind.ServiceTime]: [SiteProviderType.Projection, SiteProviderType.Prediction],
  [SiteProviderKind.Units]: [SiteProviderType.Projection],
  [SiteProviderKind.DeliveryTime]: [SiteProviderType.Prediction]
};

/**
 * Translation prefix per kind, reused from the Scheduling Project template dialog so a provider
 * type reads the same wherever it is shown. A label is `<prefix>.<providerType>`.
 */
export const SITE_PROVIDER_TYPE_LABEL_PREFIX: { [key in SiteProviderKind]: string } = {
  [SiteProviderKind.ServiceTime]: 'VISIT_SLOT_SERVICE_TIME_PROVIDERS',
  [SiteProviderKind.Units]: 'VISIT_SLOT_UNITS_PROVIDERS',
  [SiteProviderKind.DeliveryTime]: 'VISIT_SLOT_DELIVERY_TIME_PROVIDERS'
};

export function siteProviderTypeLabelKey(kind: SiteProviderKind, type: SiteProviderType): string {
  return `${SITE_PROVIDER_TYPE_LABEL_PREFIX[kind]}.${type}`;
}

/**
 * Prediction is the only providerType that resolves against a model endpoint - it is the one that
 * needs an endpointId on top of the dataset / table every provider has. A projection type shows
 * no endpoint field and sends no endpointId.
 */
export function isPredictionProviderType(type: SiteProviderType): boolean {
  return type === SiteProviderType.Prediction;
}
